
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function scopePre_order2() {
                    var pre_order = this.availability === 'preorder' && this.preorder_release_date ? true : false;
                    return _createElement('article', {
                        'className': 'card',
                        'data-product-id': this.id
                    }, _createElement('div', { 'className': 'card-figure' }, _createElement('a', {
                        'href': this.custom_url,
                        'className': 'product_img_link'
                    }, _createElement('div', { 'className': 'card-img-container' }, _createElement('img', {
                        'className': 'card-image lazyautosizes lazyloaded',
                        'data-sizes': 'auto',
                        'src': this.imageOrDefault(this.images_image_thumbnail1 || this.image_thumbnail),
                        'data-src': this.images_image_thumbnail1 || this.image_thumbnail,
                        'onError': this.onImageError,
                        'alt': this.removeHTML(this.name),
                        'sizes': '50px'
                    }))), _createElement('div', { 'className': 'card-buttonGroup' }, _createElement('a', {
                        'className': 'card-button-quickview quickview',
                        'data-product-id': this.id
                    }, _createElement('svg', {}, _createElement('use', { 'xlinkHref': '#icon-eye' })), _createElement('span', { 'className': 'text' }, _translate(`product_quick_view`))), _createElement('a', {
                        'href': '/wishlist.php?action=add&product_id=' + this.id,
                        'className': 'card-button-wishlist',
                        'title': 'Add to Wish List'
                    }, _createElement('svg', {}, _createElement('use', { 'xlinkHref': '#icon-heart' })))), _createElement('div', { 'className': 'card-figcaption' }, pre_order ? [_createElement('a', {
                            'href': this.custom_url,
                            'className': 'button card-figcaption-button',
                            'data-product-id': this.id,
                            'key': '11831'
                        }, '\n          Pre-Order Now\n        ')] : null, !pre_order ? [
                        !this.has_options ? _createElement('a', {
                            'href': '/cart.php?action=add&product_id=' + this.id,
                            'className': 'button card-figcaption-button themevale_btnATC',
                            'data-product-id': this.id,
                            'key': '13801'
                        }, '\n          ', _translate(`product_add_to_cart`), '\n        ') : null,
                        this.has_options ? _createElement('a', {
                            'href': this.custom_url,
                            'className': 'button card-figcaption-button',
                            'data-product-id': this.id,
                            'key': '13803'
                        }, '\n          ', _translate(`product_select_options`), '\n        ') : null
                    ] : null)), _createElement('div', { 'className': 'card-body' }, _createElement('div', { 'className': 'card-detail' }, _createElement('p', mergeProps({
                        'className': 'card-brand',
                        'data-test-info-type': 'brandName'
                    }, { dangerouslySetInnerHTML: { __html: typeof this.brand_name === 'undefined' ? '' : this.brand_name } })), _createElement('h4', { 'className': 'card-title' }, _createElement('a', Object.assign({}, { 'href': this.custom_url }, { dangerouslySetInnerHTML: { __html: typeof this.name === 'undefined' ? '' : this.name } }))), _createElement('p', {
                        'className': 'card-rating',
                        'data-test-info-type': 'productRating'
                    }), _createElement('div', { 'className': 'card-price-wrapper' }, _createElement('div', {
                        'className': 'card-price',
                        'data-test-info-type': 'price'
                    }, this.retail_price ? _createElement('div', {
                        'className': 'price-section price-section--withoutTax rrp-price--withoutTax',
                        'key': '2510'
                    }, '\n            MSRP: ', _createElement('span', { 'className': 'price price--rrp' }, this.formatPrice(this.retail_price))) : null, _createElement('div', { 'className': 'price-section price-section--withoutTax non-sale-price--withoutTax price-none' }, _createElement('span', { 'className': 'price price--non-sale' })), _createElement('div', { 'className': 'price-section price-section--withoutTax' }, _createElement('span', { 'className': 'price price--withoutTax' }, this.formatPrice(this.price))))), _createElement('div', { 'className': 'card-desciption' }, _createElement('p', mergeProps({ 'className': 'card-text' }, { dangerouslySetInnerHTML: { __html: typeof this.name === 'undefined' ? '' : this.name } })))), _createElement('div', { 'className': 'card-actions' }, _createElement('div', { 'className': 'card-figcaption' }, pre_order ? [_createElement('a', {
                            'href': this.custom_url,
                            'className': 'button card-figcaption-button',
                            'data-product-id': this.id,
                            'key': '33781'
                        }, '\n            Pre-Order Now\n          ')] : null, !pre_order ? [
                        !this.has_options ? _createElement('a', {
                            'href': '/cart.php?action=add&product_id=' + this.id,
                            'className': 'button card-figcaption-button themevale_btnATC',
                            'data-product-id': this.id,
                            'key': '35851'
                        }, '\n            ', _translate(`product_add_to_cart`), '\n          ') : null,
                        this.has_options ? _createElement('a', {
                            'href': this.custom_url,
                            'className': 'button card-figcaption-button',
                            'data-product-id': this.id,
                            'key': '35853'
                        }, '\n            ', _translate(`product_select_options`), '\n          ') : null
                    ] : null), _createElement('div', { 'className': 'form-wishlist' }, _createElement('a', {
                        'href': '#',
                        'aria-expanded': 'false',
                        'className': 'button button--dropdown dropdown-menu-button',
                        'data-dropdown': 'wishlist-dropdown_' + this.id
                    }, _createElement('svg', { 'className': 'icon' }, _createElement('use', { 'xlinkHref': '#icon-heart' })), _createElement('span', {}, 'Add to Wish List'), _createElement('svg', { 'className': 'icon icon-down' }, _createElement('use', { 'xlinkHref': '#icon-keyboard-arrow-down' }))), _createElement('ul', {
                        'aria-hidden': 'true',
                        'className': 'dropdown-menu',
                        'data-dropdown-content': true,
                        'id': 'wishlist-dropdown_' + this.id,
                        'tabIndex': '-1'
                    }, _createElement('li', {}, _createElement('a', { 'href': '/wishlist.php?action=add&product_id=' + this.id }, 'Add to My Wish List')), _createElement('li', {}, _createElement('a', { 'href': '/wishlist.php?action=addwishlist&product_id=' + this.id }, 'Create New Wish List')))), _createElement('label', {
                        'className': 'card-compare',
                        'htmlFor': 'compare2-' + this.id
                    }, _createElement('input', {
                        'type': 'checkbox',
                        'name': 'products[]',
                        'value': this.id,
                        'id': 'compare2-' + this.id,
                        'data-compare-id': this.id
                    }), _createElement('span', {}, 'Compare')))));
                }
                return _createElement('div', { 'className': 'productCarousel-slide' }, scopePre_order2.apply(this, []));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-items-container' }, _createElement('div', { 'className': 'toggle-title' }, _createElement('h4', { 'className': 'page-heading' }, 'You may also like...')), _createElement('div', {
        'className': 'toggle-content is-open',
        'id': 'productRelated-content',
        'aria-hidden': 'false'
    }, _createElement.apply(this, [
        'div',
        {
            'className': 'productCarousel cmRepeater_items',
            'data-slick': window.Convermax.product.dataSlick
        },
        _map(this.items, repeatItems1.bind(this))
    ])));
}
        export const componentNames = []